import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { RamRolesOptions } from '../../../enums/user-permission.enum';

@Component({
  selector: 'app-user-ram-role-selection',
  templateUrl: './user-ram-role-selection.component.html',
  styleUrls: ['./user-ram-role-selection.component.scss'],
})
export class UserRamRoleSelectionComponent implements OnInit {
  ramRolesOptions: string[];
  securityRolesForm: FormGroup;
  selectedRoles: string[];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UserRamRoleSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public userRamRoles: any
  ) {
    this.ramRolesOptions = RamRolesOptions.getAllTextValues().filter((role) => role.startsWith('TST'));
    this.selectedRoles =
      this.userRamRoles?.ramRoles?.filter((role) => role.startsWith('TST') && this.ramRolesOptions.includes(role)) ||
      [];
  }

  ngOnInit(): void {
    this.ramRolesOptions = RamRolesOptions.getAllTextValues().filter((role) => role.startsWith('TST'));

    const selectedRoles =
      this.userRamRoles?.ramRoles?.filter((role) => role.startsWith('TST') && this.ramRolesOptions.includes(role)) ||
      [];
    this.selectedRoles = selectedRoles;
    this.securityRolesForm = this.fb.group({
      selectedRamRoles: this.fb.array(this.ramRolesOptions.map((role) => selectedRoles.includes(role))),
    });
  }

  close() {
    this.dialogRef.close(this.selectedRoles);
  }

  get selectedRamRolesArray(): FormArray {
    return this.securityRolesForm.get('selectedRamRoles') as FormArray;
  }

  ramRolesSelection(): void {
    const selected = this.securityRolesForm.value.selectedRamRoles
      .map((checked: boolean, i: number) => (checked ? this.ramRolesOptions[i] : null))
      .filter((role) => role !== null);
    this.selectedRoles = selected;
    this.close();
  }

  isAllSelected(): boolean {
    return this.selectedRamRolesArray.controls.every((control) => control.value === true);
  }

  toggleSelectAll(checked: boolean): void {
    this.selectedRamRolesArray.controls.forEach((control) => control.setValue(checked));
  }
}
